export default __webpack_public_path__ + "static/assets/med_x_insulin_pen_mask.389372c9.png";